import { pushEnrichedEventToDataLayerWithCleanUp } from "seneca-common/features/analytics";
import { EnrichedEventType } from "seneca-common/features/analytics/gtm/dataLayer";
import { withLogAndSwallowError } from "seneca-common/utils/senecaAnalytics";

import { ProviderSSO } from "../types";
import manageAuthCorrelationId from "./manageAuthCorrelationId";

const authCorrelationId = manageAuthCorrelationId();

const makeEventName = (name: string) => `s/auth/firebase/${name}`;

export function logAnalyticsAuthStart({
  providerId
}: {
  providerId: ProviderSSO;
}) {
  const correlationId = authCorrelationId?.create();

  logAnalyticsEvent({
    event: makeEventName("start"),
    payload: { correlationId, providerId }
  });
}

export function logAnalyticsAuthSuccess({
  providerId,
  providerUserId
}: {
  providerId?: ProviderSSO;
  providerUserId?: string;
}) {
  const correlationId = authCorrelationId?.get();
  if (!correlationId) return;

  logAnalyticsEvent({
    event: makeEventName("success"),
    payload: { correlationId, providerId, providerUserId }
  });

  authCorrelationId?.remove();
}

export function logAnalyticsAuthFailure() {
  const correlationId = authCorrelationId?.get();
  if (!correlationId) return;

  logAnalyticsEvent({
    event: makeEventName("failure"),
    payload: { correlationId }
  });

  authCorrelationId?.remove();
}

export function logAnalyticsAuthError({
  error,
  providerId
}: {
  error: string;
  providerId: ProviderSSO;
}) {
  const correlationId = authCorrelationId?.get();
  if (!correlationId) return;

  logAnalyticsEvent({
    event: makeEventName("error"),
    payload: { correlationId, providerId, error }
  });

  authCorrelationId?.remove();
}

function logAnalyticsEvent(event: EnrichedEventType) {
  return withLogAndSwallowError(() =>
    pushEnrichedEventToDataLayerWithCleanUp(event)
  )();
}
